import { render } from "./ConsentCode.vue?vue&type=template&id=5b52e03e"
import script from "./ConsentCode.vue?vue&type=script&lang=js"
export * from "./ConsentCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__